import {useContext} from 'react';
import {Tooltip, Errors, GetPremium} from '../../../../../partials/Partials';
import {LawyerContext} from '../../../../../partials/Context';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";


function Respond(props) {
    const {message, handleChange, submitResponse, getResponse, errors, responded_problems_count} = props

    let text1 = `Odpowiadaj na pytania potencjalnych klientów i zdobądź certyfikat „Pomocnego Prawnika”.`
    let text2 = 'Prawnicy, którzy udzielają szybkich porad pozyskują nawet 10 razy więcej kontaktów do klientów, niż inni użytkownicy!'

    const lawyer = useContext(LawyerContext);
    const {photo_url, is_premium, is_non_test_premium} = lawyer

    const handleKeyDown = (e) => {
        e.target.style.height = 'inherit';
        e.target.style.height = `${e.target.scrollHeight}px`;
    }

    const handleKeyPress = (e) => {
        let key = window.event.keyCode
        if (key === 13) {
            let current_height = parseInt(e.target.style.height.slice(0,-2))
            e.target.style.height = `${String(current_height + 24)}px`
        }
    }
    let tooltip = ''

    if (responded_problems_count < 20) {
        tooltip = <Tooltip text1={text1} text2={text2}/>
    }

    if(is_premium === false) {
        return (
            <form name="response_form" onSubmit={submitResponse} novalidate>
                <Errors errors={errors}/>
                <div>
                    <GetPremium />
                </div>
            </form>
        )
    } else if (is_premium) {
        return (
            <form name="response_form" onSubmit={submitResponse}noValidate>
                <Errors errors={errors}/>
                <img className='img' src={photo_url} alt="zdjęcie profilowe prawnika"/>
                <div className="input-group-container"  >
                    <div className="input-group" >
                        <textarea onKeyDown={handleKeyDown} onKeyPress={handleKeyPress}
                            value={message}
                            onChange={handleChange}
                            id="responseMsgInput"
                            className="form-control"
                            placeholder="Twoja odpowiedź..."
                                required="required">
                        </textarea>
                        <span className="input-group-btn" >
                            <button type="submit" className="btn btn-link">
                            <FontAwesomeIcon className="fa-arrow-right fa-md"icon={faArrowRight} />
                            Wyślij
                            </button>
                        </span>
                    </div>
                    {is_non_test_premium ? (
                    <div className="input-group-btn">
                        <button type="button" id="get-response" className="btn btn-primary" onClick={getResponse}>
                            Uzyskaj propozycję odpowiedzi od AI
                        </button>
                    </div>
                    ) : <></>}
                </div>
                {tooltip}
            </form>
        )
    }
}

export default Respond;